export const addCommas = number =>
  Number.isInteger(number) ? number.toLocaleString('en-US') : '-'
